module.exports = {"441502001":"新港街道","441502002":"香洲街道","441502003":"凤山街道","441502004":"田墘街道","441502005":"东洲街道","441502006":"遮浪街道","441502007":"马宫街道","441502100":"红草镇","441502102":"东涌镇","441502103":"捷胜镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441502.json
// module id = 1858
// module chunks = 0